module.exports = __webpack_public_path__ + "static/media/CalSavvy.e66b912e.gif";